<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { MEMBERS } from '@/store/types';
import membersApi from '../../apis/members.api';

export default {
  props: {},

  setup() {
    const store = useStore();
    const query = ref(null);
    query.value = membersApi.useMembersStatsQuery();
    if (query.value) {
      store.commit(MEMBERS.SET_MEMBERS_STATS_QUERY, query);
    }
    return { query };
  },
};
</script>
